export const translations = {
  isCompatibleWith: {
    'en': 'is compatible with',
    'fr': 'est compatible avec',
    'pl': 'jest zgodny z',
    'de': 'ist kompatibel mit',
    'es': 'es compatible con',
    'fi': 'on yhteensopiva seuraavien kanssa'
  }
};
